import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-5 py-16 sm:py-20" data-id="element-70" data-mp="26ne981q0bbd6">
      <div className="mx-auto max-w-5xl" data-id="element-71" data-mp="22krf1u5v5ect">
        <h2 className="text-center font-display text-[28px] font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-72" data-mp="22m2fbk03o3z6">
          From Scattered Observations to a Connected Intervention Plan
        </h2>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-73" data-mp="2ud8kieuogrvb">
          <div className="overflow-hidden rounded-3xl border-2 border-danger/30 bg-white" data-id="element-74" data-mp="2q9u2xjr3c3fr">
            <div className="bg-danger px-5 py-4 text-center" data-id="element-75" data-mp="2lbirx5p27mvy">
              <p className="font-display text-2xl font-extrabold text-white" data-id="element-76" data-mp="2laz79h80yke8">BEFORE</p>
              <p className="text-sm font-semibold text-white/90" data-id="element-77" data-mp="1ewrlynl2xbv2">Without a structured workflow</p>
            </div>
            <ul className="space-y-3 p-5" data-id="element-78" data-mp="19y6lcn1x0q63">
              {beforeItems.map(t => <li key={t} className="flex gap-3 rounded-xl bg-danger-light p-3 text-[15px] font-medium text-navy" data-id="element-79" data-mp="1765m2k1h62rp">
                  <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-80" data-mp="1c2cqu9i4x882" />
                  {t}
                </li>)}
            </ul>
          </div>

          <div className="overflow-hidden rounded-3xl border-2 border-brand/40 bg-white" data-id="element-81" data-mp="135vh9apf5ief">
            <div className="bg-brand px-5 py-4 text-center" data-id="element-82" data-mp="odjtq9ps0ubv">
              <p className="font-display text-2xl font-extrabold text-white" data-id="element-83" data-mp="t5usvacp0c3d">AFTER</p>
              <p className="text-sm font-semibold text-white/90" data-id="element-84" data-mp="feq1evjhaq44">With the Pediatric Motor Planning Pathway™</p>
            </div>
            <ul className="space-y-3 p-5" data-id="element-85" data-mp="jgl2byxhz1hd">
              {afterItems.map(t => <li key={t} className="flex gap-3 rounded-xl bg-brand-light p-3 text-[15px] font-medium text-navy" data-id="element-86" data-mp="5fqr78j2emf0">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-87" data-mp="adsb1vobeprj" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-10 text-center font-display text-xl font-extrabold text-navy" data-id="element-88" data-mp="27bznlfya6hld">One Case. One Connected Planning Workflow.</p>
        <SectionCTA label="Get the Complete Planning System" data-id="element-89" data-mp="239l1mmzbf1pv" />
      </div>
    </section>;
}